import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Button,
  Tooltip,
} from "@mui/material";
import React from "react";
import { Cross } from "../assets/icons";
import Styles from "../../styles/vendorDashboard.module.css";

const SowViewModal = ({
  isViewModal,
  setIsViewModal,
  rfpData,
  isProductDimensions,
  SOWUpdateDetails,
  locationListUpdate,
}) => {
  const handleClose = () => {
    setIsViewModal(false);
  };

  return (
    <Dialog open={isViewModal} maxWidth="xl">
      <div className={`flex justify-between ${Styles.vendorModalColor}`}>
        <DialogTitle>Scope of work details </DialogTitle>
        <div
          onClick={handleClose}
          className="mx-5 my-4"
          style={{ cursor: "pointer" }}
        >
          <Cross />
        </div>
      </div>
      <DialogContent className={Styles.vendorModalColor}>
        <Box>
          {/* personal details */}
          <div className="flex items-center justify-between">
            <div className="text-center bg-white rounded-lg shadow-md p-6 mb-4 w-96">
              <img
                src={
                  rfpData?.organizationId?.brandLogo ||
                  "/assests/AdminDashboard/userForIP.webp"
                }
                alt="Profile Logo"
                className="w-28 h-28 rounded-full mx-auto mb-4 cursor-pointer"
              />
              <h2 className="text-xl font-semibold">
                <Tooltip
                  title={
                    rfpData?.organizationId.name?.length > 17
                      ? rfpData?.organizationId.name
                      : ""
                  }
                  arrow
                  placement="top"
                >
                  {rfpData?.organizationId?.name.length > 17
                    ? rfpData?.organizationId?.name.slice(0, 17) + "..."
                    : rfpData?.organizationId?.name || "N/A"}
                </Tooltip>
              </h2>
              <p className="text-gray-500">{rfpData?.campaignName || "N/A"}</p>
            </div>
            <div className="  bg-white rounded-lg shadow-md p-6 mb-4 ml-4 w-full">
              <h3 className="text-xl font-bold  text-gray-600 mb-4">
                Campaign Info
              </h3>
              <hr />
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                <div className="flex flex-col">
                  <span className="font-bold text-gray-600">
                    Product Category
                  </span>
                  <span className="text-gray-600 break-words">
                    {isProductDimensions?.[0]?.productType || "N/A"}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="font-bold text-gray-600">Services</span>
                  <span className="text-gray-600 break-words">
                    {SOWUpdateDetails?.servicesNeeded?.join(",")}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="font-bold text-gray-600">Experience</span>
                  <span className="text-gray-600 break-words">
                    {SOWUpdateDetails?.experienceOfFabrication || "N/A"}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="font-bold text-gray-600">Total Area</span>
                  <span className="text-gray-600 break-words">
                    {SOWUpdateDetails?.totalArea || "N/A"}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="font-bold text-gray-600">Price</span>
                  <span className="text-gray-600 break-words">
                    {SOWUpdateDetails?.price || "N/A"}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="font-bold text-gray-600">
                    Total Campaign Value
                  </span>
                  <span className="text-gray-600 break-words">
                    {SOWUpdateDetails?.budget || "N/A"}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* cad file */}
          <div className="Sbg-white rounded-lg shadow-md p-6 mb-4">
            <div>
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold  text-gray-600 mb-4">
                  Product Rendition Reference
                </h3>

                {SOWUpdateDetails?.materialDetailsForFabrication?.cadFile && (
                  <Button
                    onClick={() =>
                      window.open(
                        SOWUpdateDetails?.materialDetailsForFabrication.cadFile,
                        "_blank"
                      )
                    }
                  >
                    View CAD File
                  </Button>
                )}
              </div>

              <hr />
              <div className="flex justify-between items-center mt-10">
                <img
                  src={
                    isProductDimensions?.[0]?.printImage
                      ? isProductDimensions?.[0]?.printImage
                      : "/assests/AdminDashboard/SowDummyimage.png"
                  }
                  alt="Profile Logo"
                  className=" mx-auto mb-4 cursor-pointer w-64 lg:w-96 h-auto"
                />
                <img
                  src={
                    isProductDimensions?.[0]?.productSecondImg
                      ? isProductDimensions?.[0]?.productSecondImg
                      : "/assests/AdminDashboard/SowDummyimage.png"
                  }
                  alt="Profile Logo"
                  className=" mx-auto mb-4 cursor-pointer w-64 lg:w-96 h-auto"
                />
              </div>
            </div>
          </div>
          {/* sites */}
          <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
            <div>
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold  text-gray-600 mb-4">Sites</h3>
              </div>

              <hr />
              <div className="flex justify-center items-center mt-2">
                <div className="overflow-x-auto border rounded-lg h-80">
                  <table className="min-w-full bg-white border-collapse">
                    <thead className="bg-gray-100 border-b sticky top-0">
                      <tr>
                        {[
                          "S. No.",
                          "Store Name",
                          "Store Manager",
                          "Address",
                          "Pin Code",
                          "City/State",
                          "Width",
                          "Height",
                          "Thickness",
                        ].map((header) => (
                          <th key={header} className="text-left px-4 py-2">
                            {header}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {locationListUpdate?.map((item, index) => (
                        <tr key={index} className="border-b">
                          <td className="px-4 py-2 text-sm">{index + 1}</td>
                          <td className="px-4 py-2 text-sm">
                            {item?.storeName || "N/A"}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {item?.storeOwnerName || "N/A"} <br />
                            <span className="text-gray-500 text-xs">
                              {item?.storeOwnerPhoneNumber || "N/A"}
                            </span>
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {item?.address || "N/A"}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {item?.zipCode || "N/A"}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {item?.state || "N/A"},{item?.city || "N/A"}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {isProductDimensions[index]?.productWidth || "N/A"}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {isProductDimensions[index]?.productHeight || "N/A"}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {isProductDimensions[index]?.productThickness ||
                              "N/A"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {/* fabrication machine required */}
          {SOWUpdateDetails?.machinesNeededForFabrication?.length !== 0 && (
            <div className="bg-white rounded-lg shadow-md p-6 mb-4">
              <div className="rounded-lg">
                <div className="flex justify-between items-center">
                  <h3 className="text-xl font-bold  text-gray-600 mb-4">
                    Fabrication Machines Required
                  </h3>
                </div>
                <hr />
                {SOWUpdateDetails?.machinesNeededForFabrication?.map(
                  (machine, index) => (
                    <div
                      key={index}
                      className="bg-white shadow-sm rounded-lg p-4 mb-4 mt-4 border"
                    >
                      <h3 className="text-lg font-semibold border-b pb-2">
                        {machine?.type || "N/A"}
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 text-sm text-gray-700">
                        {machine?.details?.subCategory && (
                          <div>
                            <p className="font-semibold">Sub Category</p>
                            <p>{machine?.details?.subCategory || "N/A"}</p>
                          </div>
                        )}

                        {machine?.details?.ampereOfMachine && (
                          <div>
                            <p className="font-semibold">Ampere Of Machine</p>
                            <p>{machine?.details?.ampereOfMachine || "N/A"}</p>
                          </div>
                        )}
                        {machine?.details?.controllerSetting && (
                          <div>
                            <p className="font-semibold">Controller Setting</p>
                            <p>
                              {machine?.details?.controllerSetting || "N/A"}
                            </p>
                          </div>
                        )}
                        {machine?.details?.ageOfMachine && (
                          <div>
                            <p className="font-semibold">Age Of Machine</p>
                            <p>{machine?.details?.ageOfMachine || "N/A"}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          )}
          {/* printing machine required */}
          {SOWUpdateDetails?.machinesNeededForPrinting?.length !== 0 && (
            <div className="bg-white rounded-lg shadow-md p-6 mb-4">
              <div className="rounded-lg">
                <div className="flex justify-between items-center">
                  <h3 className="text-xl font-bold  text-gray-600 mb-4">
                    Printing machines Required
                  </h3>
                </div>
                <hr />
                {SOWUpdateDetails?.machinesNeededForPrinting?.map(
                  (machine, index) => (
                    <div
                      key={index}
                      className="bg-white shadow-sm rounded-lg p-4 mb-4 border"
                    >
                      <h3 className="text-lg font-semibold border-b pb-2">
                        {machine?.type}
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 text-sm text-gray-700">
                        <div>
                          <p className="font-semibold">Type Of Printer Head</p>
                          <p>
                            {machine?.details?.machinePrintingSubType || "N/A"}
                          </p>
                        </div>
                        <div>
                          <p className="font-semibold">Brand</p>
                          <p>{machine?.details?.machineBrand || "N/A"}</p>
                        </div>
                        <div>
                          <p className="font-semibold">Picoliter</p>
                          <p>{machine?.details?.picoliter || "N/A"}</p>
                        </div>
                        <div>
                          <p className="font-semibold">
                            Machine Max Print Size
                          </p>
                          <p>{machine?.details?.maxPrintSize || "N/A"}</p>
                        </div>
                        <div>
                          <p className="font-semibold">Machine Age</p>
                          <p>{machine?.details?.ageOfMachine || "N/A"}</p>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          )}

          <div className="bg-white rounded-lg shadow-md p-6 mb-4">
            <div className="rounded-lg">
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold  text-gray-600 mb-4">
                  Fabrication Material Specifications
                </h3>
              </div>
              <hr />
              <div className="bg-white shadow-sm rounded-lg p-4 mb-4 border">
                <h3 className="text-lg font-semibold border-b pb-2">
                  Mechanical
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 text-sm text-gray-700">
                  <div>
                    <p className="font-semibold">Frame Section</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.frameDetailsections || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Frame Wall Thickness</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.frameDetailwallThickness || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Approx. Frame Weight</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.frameDetailweight || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Size</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication?.size ||
                        "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Backing Material</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.backingmaterial || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Backing Thickness</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.backingthickness || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Backing Grade</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.backinggrade || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Raising Height</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.raisingheight || "N/A"}
                    </p>
                  </div>{" "}
                  <div>
                    <p className="font-semibold">Raising Material</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.raisingmaterial || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Raising Thickness</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.raisingthickness || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Raising Grade</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.raisinggrade || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Application Place</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.applicationPlace || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Face</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication?.face ||
                        "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Additional Specifications</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.specialMentions || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white shadow-sm rounded-lg p-4 mb-4 border">
                <h3 className="text-lg font-semibold border-b pb-2">
                  Electrical
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 text-sm text-gray-700">
                  <div>
                    <p className="font-semibold">Light Source Type</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.lightSourcetype || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Light Source Brand</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.lightSourcebrand || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Light Source Model Number</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.lightSourcemodelNo || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Light Source Quantity</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.lightSourceqty || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Light Source Color Temp</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.lightSourcecolorTemp || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Light Source Wattage</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.lightSourcewattage || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Wiring Size</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.wiringsize || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Wiring Type</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.wiringtype || "N/A"}
                    </p>
                  </div>{" "}
                  <div>
                    <p className="font-semibold">Wiring Brand</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication
                        ?.wiringbrand || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white shadow-sm rounded-lg p-4 mb-4 border">
                <h3 className="text-lg font-semibold border-b pb-2">Paint</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 text-sm text-gray-700">
                  <div>
                    <p className="font-semibold">Paint</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForFabrication?.paint ||
                        "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6 mb-4">
            <div className="rounded-lg">
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold  text-gray-600 mb-4">
                  Printing Material Specifications
                </h3>
              </div>
              <hr />
              <div className="bg-white shadow-sm rounded-lg p-4 mb-4 border">
                <h3 className="text-lg font-semibold border-b pb-2">
                  Print Specifications
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 text-sm text-gray-700">
                  <div>
                    <p className="font-semibold">Print Material Substrate</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForPrinting
                        ?.printMaterialsubstrate || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Print Material Brand</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForPrinting
                        ?.printMaterialbrand || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Print Material Guide</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForPrinting
                        ?.printMaterialgrade || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Art Work (Max Size)</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForPrinting?.artWork ||
                        "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Outer Size</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForPrinting
                        ?.outerSize || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Brand</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForPrinting?.brand ||
                        "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Application Place</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForPrinting
                        ?.applicationPlace || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Installation Wall</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForPrinting
                        ?.applicationPlace || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Installation Ceiling</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForPrinting
                        ?.installationceiling || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Installation Projected</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForPrinting
                        ?.installationprojected || "N/A"}
                    </p>
                  </div>{" "}
                  <div>
                    <p className="font-semibold">Installation Floor</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForPrinting
                        ?.installationfloor || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Installation Table Top</p>
                    <p>
                      {SOWUpdateDetails?.materialDetailsForPrinting
                        ?.installationtableTop || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white shadow-sm rounded-lg p-4 mb-4 border">
                <h3 className="text-lg font-semibold border-b pb-2">
                  Electrical
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 text-sm text-gray-700">
                  <div>
                    <p className="font-semibold">Print DPI</p>
                    <p>
                      {SOWUpdateDetails?.printingParametersForPrinting
                        ?.printDPI || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Color Code</p>
                    <p>
                      {SOWUpdateDetails?.printingParametersForPrinting
                        ?.colorCode || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Type Of Color Code</p>
                    <p>
                      {SOWUpdateDetails?.printingParametersForPrinting
                        ?.colorCodeDetails || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Layer</p>
                    <p>
                      {SOWUpdateDetails?.printingParametersForPrinting?.layer ||
                        "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Passes</p>
                    <p>
                      {SOWUpdateDetails?.printingParametersForPrinting
                        ?.passes || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold">Print On Slides</p>
                    <p>
                      {SOWUpdateDetails?.printingParametersForPrinting
                        ?.printOnSides || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Box>
        {/* <table className="table-auto border-collapse w-full">
          <tbody>
            {campaignDetails?.map((item, index) => (
              <tr key={index}>
                <td
                  className="border px-4 py-2"
                  style={{ color: "var(--heading-color)", width: "50%" }}
                >
                  {item.label}
                </td>
                <td
                  className="border px-4 py-2"
                  style={{ color: "var(--para-color)", width: "50%" }}
                >
                  {item.value || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table> */}
      </DialogContent>
    </Dialog>
  );
};

export default SowViewModal;
